import api from 'api';
import { DesignItems } from 'records/DesignItem';

export const DESIGN_ITEMS_ASYNC_ACTION_START = 'DESIGN_ITEMS_ASYNC_ACTION_START';
export const DESIGN_ITEMS_ASYNC_ACTION_ERROR = 'DESIGN_ITEMS_ASYNC_ACTION_ERROR';
export const DESIGN_ITEMS_ASYNC_ACTION_SUCCESS = 'DESIGN_ITEMS_ASYNC_ACTION_SUCCESS';
export const DESIGN_ITEMS_UPDATE_ACTION_SUCCESS = 'DESIGN_ITEMS_UPDATE_ACTION_SUCCESS';
export const DESIGN_ITEMS_RESET_STATE = 'DESIGN_ITEMS_RESET_STATE';

function designItemsAsyncActionStart() {
  return {
    type: DESIGN_ITEMS_ASYNC_ACTION_START,
  };
}

function designItemsAsyncActionError(error) {
  return {
    type: DESIGN_ITEMS_ASYNC_ACTION_ERROR,
    error,
  };
}

function designItemsAsyncUpdateSuccess(data) {
  return {
    type: DESIGN_ITEMS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function updateDesignItems(data) {
  return {
    type: DESIGN_ITEMS_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetDesignItemsState() {
  return {
    type: DESIGN_ITEMS_RESET_STATE,
  };
}

export function getDesignItemsAsync(designId) {
  return (dispatch, getState) => {
    dispatch(designItemsAsyncActionStart());
    return api.request(`designitem/list?designId=${ designId }`, 'get')
    .then((data) => {
      dispatch(designItemsAsyncUpdateSuccess(data));
      return DesignItems(data);
    })
    .catch((err) => {
      dispatch(designItemsAsyncActionError('Unable to get Design Items'));
      throw (err);
    });
  };
}
